import DashBoard from './DashBoard.container';

export default DashBoard;
